/**
 * The tour of a monitoring workflow's quarter board (DOP-625), on the KPI
 * dashboard's spotlight (`Tour/SpotlightTour`). Runs once per person, the
 * first time a board with a period is opened; "Take the tour" replays it.
 */

import React from "react";
import SpotlightTour, { type TourStep } from "../Tour/SpotlightTour";

const STEPS: readonly TourStep[] = [
	{
		anchor: '[data-tour="period-strip"]',
		title: "Every quarter, side by side",
		body: "Pick the quarter you're working on. Each one says whether it's locked or when its packages are due.",
		note: "New period adds the next quarter when it starts.",
		next: "Next: what needs you",
	},
	{
		anchor: '[data-testid="board-tiles"]',
		title: "The quarter at a glance",
		body: "How many borrowers need you, which covenants are near or over a limit, and which packages are still out.",
		next: "Next: your borrowers",
	},
	{
		anchor: '[data-testid="period-board"]',
		title: "One row per borrower",
		body: "Each borrower shows where it stands this quarter and one next step. Open a borrower to see every figure and the page it came from.",
		next: "Next: running packages",
	},
	{
		anchor: '[data-tour="run-received"]',
		title: "Run every package that's in",
		body: "Doppler reads each package that has arrived and fills in the monitoring workbook. Borrowers still waiting on a package are skipped.",
		next: "Next: checks",
	},
	{
		anchor: '[data-tab-id="review"]',
		title: "Checks land in Needs you",
		body: "Figures Doppler couldn't find or confirm, for every borrower, in one list. Answer each one before you lock the quarter.",
		next: "Next: the setup",
	},
	{
		anchor: '[data-tab-id="setup"]',
		title: "Change what's tracked",
		body: "The figures Doppler pulls from each package and what happens when one is missing. The next run uses whatever you set here.",
		next: "Got it",
	},
];

const MonitoringTour: React.FC<{ onClose: () => void }> = ({ onClose }) => (
	<SpotlightTour steps={STEPS} onClose={onClose} testId="monitoring-tour-backdrop" />
);

export default MonitoringTour;
